import {Component, OnInit} from '@angular/core';
import {ApiService} from '@app/api/api.service';
import {CurrencyPipe} from '@angular/common';
import {Router} from '@angular/router';
import Swal from 'sweetalert2';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-formorder',
  templateUrl: './formorder.component.html',
  styleUrls: ['./formorder.component.css']
})
export class FormOrderComponent implements OnInit {

  constructor(
    public api: ApiService,
    public currencyPipe: CurrencyPipe,
    public router: Router,
    private fb: FormBuilder
  ) {
  }

  formData!: FormGroup;
  provinces: [];
  cities: [];
  districts: [];
  subdistricts: [];
  products: [];
  shippings: string[];
  shippingType = 'REG';
  shippingOrigin = 'JKT';

  selectedProduct = null;

  loadingProvince = false;
  loadingCity = false;
  loadingDistrict = false;
  loadingSubdistrict = false;
  loadingPostalCode = false;
  loadingProduct = false;

  selectedProvince = null;
  selectedDistrict = null;
  selectedCity = null;
  selectedShipping = null;

  // formData = {
  //   name: '',
  //   email: '',
  //   province: null,
  //   city: null,
  //   district: null,
  //   subdistrict: null,
  //   phone: '',
  //   address: '',
  //   rt: '',
  //   rw: '',
  //   postalCode: null,
  //   product: null,
  //   weight: 1,
  //   shipper: '',
  //   shippingCost: 0,
  //   shippingCostTotal: 0,
  //   shippingDiscount: 0,
  //   subtotalProduk: 0,
  //   price: null,
  //   qty: 0,
  //   totalOrder: 0
  // };

  qrisString = '';
  remainingTime = 0;
  showQrisModal = false;
  private qrisTimer: any;
  trxId = 0;

  ngOnInit(): void {
    this.fetchProvince();
    this.fetchProduct();
    this.formData = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      province: [null, Validators.required],
      city: [null, Validators.required],
      district: [null, Validators.required],
      subdistrict: [null, Validators.required],
      phone: ['', Validators.required],
      address: ['', Validators.required],
      rt: ['', Validators.required],
      rw: ['', Validators.required],
      postalCode: [null, Validators.required],
      product: [null, Validators.required],
      weight: [1, [Validators.required, Validators.min(1)]],
      shipper: ['', Validators.required],
      shippingCost: [0],
      shippingCostTotal: [0],
      shippingDiscount: [0],
      subtotalProduk: [0],
      price: [null, Validators.required],
      qty: [0, [Validators.required, Validators.min(1)]],
      totalOrder: [0]
    });
  }

  fetchProvince() {
    this.loadingProvince = true;
    return this.api.GetProvince().subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.provinces = output['data'];
      this.loadingProvince = false;
    });
  }

  fetchShipping() {
    // let querystr = '';
    return this.api.GetStoreKurir('').subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.shippings = [output['data'][0]];
      // tslint:disable-next-line:no-string-literal
      this.shippings[0]['name'] = 'Kurir Rekomendasi';
    });
  }

  onProvinceChange(province: any) {
    const provinceId = province ? province.id : null;
    this.selectedProvince = province;
    // this.formData.province = provinceId;
    // this.formData.city = null;
    // this.formData.district = null;
    // this.formData.subdistrict = null;
    this.formData.patchValue({
      province: provinceId,
      city: null,
      district: null,
      subdistrict: null
    });
    this.cities = [];
    this.districts = [];
    this.subdistricts = [];
    if (provinceId) {
      this.fetchCity(provinceId);
    }
  }

  onCityChange(city: any) {
    const cityId = city ? city.id : null;
    this.selectedCity = city;
    this.formData.patchValue({
      city: cityId,
      district: null,
      subdistrict: null,
    });
    // this.formData.city = cityId;
    // this.formData.district = null;
    // this.formData.subdistrict = null;
    this.districts = [];
    this.subdistricts = [];
    if (cityId) {
      this.fetchDistrict(cityId);
    }
  }

  onDistrictChange(district: any) {
    const districtId = district ? district.id : null;
    this.selectedDistrict = district;
    this.formData.patchValue({
      district: districtId,
      subdistrict: null,
      postalCode: null,
    });
    // this.formData.district = districtId;
    // this.formData.subdistrict = null;
    // this.formData.postalCode = null;
    this.subdistricts = [];
    if (districtId) {
      this.fetchSubDistrict(districtId);
    }
  }

  onSubDistrictChange(subdistrict: any) {
    const subdistrictId = subdistrict ? subdistrict.id : null;
    // this.formData.subdistrict = subdistrictId;
    this.formData.patchValue({
      subdistrict: subdistrictId,
    });
    if (subdistrictId) {
      this.fetchPostalCode(this.formData.get('district').value, subdistrict.name);
    }
  }

  onProductChange(product: any) {
    this.selectedProduct = product;
    const qty = this.formData.get('qty').value ? this.formData.get('qty').value : 1;
    this.formData.patchValue({
      product: product ? product.id : null,
      price: product ? product.price : null,
      qty: 1,
      weight: 1,
      subtotalProduk: qty * this.selectedProduct.price,
    });
    // this.formData.product = product ? product.id : null;
    // this.formData.price = product ? product.price : null;
    // this.formData.qty = 1;
    // this.formData.weight = 1;
    // this.formData.subtotalProduk = this.formData.qty * this.selectedProduct.price;
    // this.fetchShipping();
    this.calculateTotalPayment();
  }

  onQtyChange(qty: number): void {
    const parsedQty = Number(qty);
    const baseWeightPerItem = 1;
    console.log(parsedQty);
    console.log(this.selectedProduct);
    // Hitung ulang total berat
    this.formData.patchValue({
      weight: parsedQty * baseWeightPerItem,
      subtotalProduk: this.selectedProduct ? (qty * this.selectedProduct.price) : 0,
    });
    // this.formData.weight = parsedQty * baseWeightPerItem;
    // this.formData.subtotalProduk = qty * this.selectedProduct.price;
    this.onShippingChange(this.formData.get('shipper').value);
  }

  onCurrencyInput(event: Event): void {
    const inputEl = event.target as HTMLInputElement;
    const rawValue = inputEl.value.replace(/[^\d]/g, '');
    // this.formData.shippingCost = parseInt(rawValue, 10) || 0;
    this.formData.patchValue({
      shippingCost: parseInt(rawValue, 10) || 0,
    });

    setTimeout(() => {
      const shippingCost = this.formData.get('shippingCost').value;
      inputEl.value =
        this.currencyPipe.transform(shippingCost ? shippingCost : 0, 'IDR', 'symbol', '1.0-0');
    });
  }

  onShippingChange(shipping: any): void {
    let shippingSelected = '';
    if (this.shippings && Array.isArray(this.shippings) && shipping) {
      // tslint:disable-next-line:no-string-literal
      this.selectedShipping = this.shippings.find(item => item['id'] === shipping['id']);
      console.log('shipping: ' + shipping.id);
      console.log('selected shipping: ' + this.selectedShipping);
      shippingSelected = this.selectedShipping.name
        ? this.selectedShipping.name.toUpperCase()
        : '';
      console.log('selected shipping name: ' + shippingSelected);

      if (shippingSelected === 'SICEPAT') {
        this.fetchOngkirSicepat({
          dest: this.selectedDistrict.name,
          kota: this.selectedCity.name,
          berat: this.formData.get('weight').value,
        });
      } else if (shippingSelected === 'KURIR REKOMENDASI') {
        this.fetchOngkirTiki({
          orig: this.shippingOrigin,
          jenis: this.shippingType,
          prov: this.selectedProvince.name,
          kec: this.selectedDistrict.name,
          kota: this.selectedCity.name,
          berat: this.formData.get('weight').value,
        });
      } else if (shippingSelected === 'MNC') {
        this.fetchOngkirMNC();
      } else {
        alert('Kurir not available');
      }
    }

    //   const selectedShipping = this.shippings.find(
    //     (item) => item.id === shipping
    //   );
    //
    //
    //   shippingSelected = selectedShipping.name
    //     ? selectedShipping.name.toUpperCase()
    //     : '';
    //
    //   console.log(shippingSelected);
    //
    //   if (shippingSelected === 'SICEPAT') {
    //     this.fetchOngkirSicepat({
    //       dest: this.selectedDistrict.name,
    //       kota: this.selectedCity.name,
    //       berat: this.formData.get('weight').value,
    //     });
    //   } else if (shippingSelected === 'TIKI') {
    //     this.fetchOngkirTiki({
    //       orig: this.shippingOrigin,
    //       jenis: this.shippingType,
    //       prov: this.selectedProvince.name,
    //       kec: this.selectedDistrict.name,
    //       kota: this.selectedCity.name,
    //       berat: this.formData.get('weight').value,
    //     });
    //   } else if (shippingSelected === 'MNC') {
    //     this.fetchOngkirMNC();
    //   } else {
    //     alert('Kurir not available');
    //   }
    // } else {
    //   console.warn('Data shipping belum tersedia.');
    // }
    //
    // console.log('Kurir dipilih:', shippingSelected); // ✅ sekarang aman dipakai di sini
  }


  fetchOngkirSicepat(querystr) {
    return this.api.GetOngkirsicepat(querystr).subscribe((output: {}) => {
      this.formData.patchValue({
        // tslint:disable-next-line:no-string-literal
        shippingCost: output['data']['tarif'],
      });
      // this.formData.shippingCost = output['data']['tarif'];
      this.calculateTotalPayment();
    });
  }

  fetchOngkirTiki(querystr) {
    return this.api.GetOngkirtiki(querystr).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      // this.formData.shippingCost = output['data']['tarif'];
      this.formData.patchValue({
        // tslint:disable-next-line:no-string-literal
        shippingCost: output['data']['tarif'],
      });
      this.calculateTotalPayment();
    });
  }

  fetchOngkirMNC() {
    // this.formData.shippingCost = 20000; // flat
    this.formData.patchValue({
      shippingCost: 20000,
    });
    // tslint:disable-next-line:no-string-literal
    this.calculateTotalPayment();
  }

  fetchCity(provinceId: string) {
    this.loadingCity = true;
    return this.api.GetCity(provinceId).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.cities = output['data'];
      this.loadingCity = false;
    });
  }

  fetchDistrict(cityId: string) {
    this.loadingDistrict = true;
    return this.api.GetDistrict(cityId).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.districts = output['data'];
      this.loadingDistrict = false;
    });
  }

  fetchSubDistrict(districtId: string) {
    this.loadingSubdistrict = true;
    return this.api.GetSubdistrict(districtId).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.subdistricts = output['data'];
      this.loadingSubdistrict = false;
      this.fetchShipping();
      // this.shippings = [
      //   'Tiki',
      //   'SiCepat',
      //   // 'MNC'
      // ];
    });
  }

  fetchPostalCode(districtId: string, subdistrictName: string) {
    this.loadingPostalCode = true;
    return this.api.GetPostalcode({district_id: districtId, subdistrict_name: subdistrictName}).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      if (output['status']) {
        // tslint:disable-next-line:no-string-literal
        this.formData.patchValue({
          // tslint:disable-next-line:no-string-literal
          postalCode: output['data'].postal_code,
        });
      } else {
        this.formData.patchValue({
          postalCode: null,
        });
      }
      this.loadingPostalCode = false;
    });
  }

  fetchProduct() {
    this.loadingProduct = true;
    const querystr = '?channel=NEXTSYSPLAY';
    return this.api.GetProduct(querystr).subscribe((output: {}) => {
      // tslint:disable-next-line:no-string-literal
      this.products = output['data'];
      this.loadingProduct = false;
    });
  }

  openQrisModal(qrisString: string, sessionTime: number) {
    this.qrisString = qrisString;
    this.remainingTime = sessionTime * 60; // 30 menit -> 1800 detik
    this.showQrisModal = true;

    this.qrisTimer = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        clearInterval(this.qrisTimer);
        // this.closeQrisModal(this.trxId); // aktifkan jika perlu
      }
    }, 1000);
  }

  formatTime(seconds: number): string {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? '0' : ''}${s}`;
  }

  closeQrisModal() {
    this.showQrisModal = false;
    clearInterval(this.qrisTimer);

    this.router.navigateByUrl('/adminecommerce/view/' + this.trxId);
  }

  async submitForm() {

    if (this.formData.invalid) {
      this.formData.markAllAsTouched(); // agar semua error langsung muncul
      return;
    }

    // Submit jika valid
    console.log('Form valid, kirim data:', this.formData);

    const confirmResult = await Swal.fire({
      title: 'Yakin submit order?',
      text: 'Pastikan data sudah benar sebelum lanjut.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya, Submit',
      cancelButtonText: 'Batal'
    });

    if (!confirmResult.isConfirmed) {
      return;
    }

    // Tampilkan loading
    Swal.fire({
      title: 'Memproses Order...',
      text: 'Mohon tunggu sebentar',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const customerData = {
      shopcode: 'NEXTSYSPLAY',
      name: this.formData.get('name').value,
      email: this.formData.get('email').value,
      nohp: this.formData.get('phone').value,
      zipcode: this.formData.get('postalCode').value,
      // tslint:disable-next-line:no-string-literal
      provinceid: this.selectedProvince['id'],
      // tslint:disable-next-line:no-string-literal
      cityid: this.selectedCity['id'],
      // tslint:disable-next-line:no-string-literal
      districtid: this.selectedDistrict['id'],
      // tslint:disable-next-line:no-string-literal
      subdistrictid: this.selectedDistrict['id'],
      // tslint:disable-next-line:no-string-literal
      subdistrictname: this.selectedDistrict['name'],
      alamat: this.formData.get('address').value + ', RT ' + this.formData.get('rt').value + ', RW ' + this.formData.get('rw').value,
      notes: 'Order by NextsysPlay'
    };

    const ordersData = [
      {
        // tslint:disable-next-line:no-string-literal
        id: this.selectedProduct['id'],
        // tslint:disable-next-line:no-string-literal
        name: this.selectedProduct['productname'],
        // tslint:disable-next-line:no-string-literal
        price: this.selectedProduct['price'],
        qty: this.formData.get('qty').value,
        total: this.formData.get('subtotalProduk').value
      }
    ];

    const ongkirData = {
      berat: this.formData.get('weight').value,
      price: this.formData.get('shippingCost').value,
      jumlah: this.formData.get('qty').value,
      total: this.formData.get('shippingCost').value
    };

    // let kurir = this.list.find(obj => obj.id == this.Courier);
    // let jenispengiriman = this.listshippingtype.find(obj => obj.id == this.shippingtype);
    // let lokgudang = this.listlokasigudang.find(obj => obj.id == this.lokasigudang);
    const date = new Date();
    const waktupickups = {year: date.getFullYear(), month: (date.getMonth() + 1), day: date.getDate()};
    const shippingData = {
      shippingname: this.selectedShipping.name,
      destination: {
        // tslint:disable-next-line:no-string-literal
        kota: this.selectedCity['name'],
        // tslint:disable-next-line:no-string-literal
        prov: this.selectedProvince['name'],
        // tslint:disable-next-line:no-string-literal
        destination: this.selectedDistrict['name'],
        zipcode: this.formData.get('postalCode').value,
      },
      price: this.formData.get('shippingCost').value,
      source: window.location.href,
      kuririd: this.selectedShipping.id,
      noresi: null,
      jenispengirimanid: null,
      jenispengiriman: null,
      marketplacelokasigudangid: null,
      marketplacelokasigudang: null,
      waktupickup: waktupickups,
    };

    const data = {
      customer: customerData,
      order: ordersData,
      ongkir: ongkirData,
      totaltagihan: this.formData.get('totalOrder').value,
      shipping: shippingData
    };

    this.api.PostCheckoutNextsys(data).subscribe({
      next: (output: any) => {
        Swal.close(); // Tutup loading

        if (output.status) {
          this.trxId = output.data.trx_id;
          const qrisString = output.data.qris_string;
          const sessionTime = output.data.qris_session_time;

          // Notifikasi sukses
          Swal.fire({
            icon: 'success',
            title: `Order Berhasil ${this.trxId}`,
            text: 'Silakan lakukan pembayaran melalui QRIS.',
            confirmButtonText: 'Lanjutkan'
          }).then(() => {
            this.openQrisModal(qrisString, sessionTime);
          });
        } else {
          // Jika status false
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: output.message || 'Order gagal dilakukan'
          });
        }
      },
      error: () => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Gagal menghubungi server.'
        });
      }
    });
  }

  calculateTotalPayment() {
    this.formData.patchValue({
      totalOrder: this.formData.get('subtotalProduk').value + this.formData.get('shippingCost').value,
    });
    // this.formData.totalOrder = this.formData.subtotalProduk + this.formData.shippingCost;
  }

  clearForm() {
    this.formData.reset({
      name: '',
      email: '',
      province: null,
      city: null,
      district: null,
      subdistrict: null,
      phone: '',
      address: '',
      rt: '',
      rw: '',
      postalCode: '',
      product: null,
      weight: 1,
      shipper: '',
      shippingCost: 0,
      shippingCostTotal: 0,
      shippingDiscount: 0,
      subtotalProduk: 0,
      price: null,
      qty: 0,
      totalOrder: 0
    });
  }

}

